namespace JupitersChoice {
    export class SetRecoveryPointCmd {

        @inject('ComponentManager') _componentManager: Sapphire.ComponentManager;
        @inject('CurrencyFormatter') _currencyFormatter: Sapphire.CurrencyFormatter;
        @inject('GameServer') _gameServer: Sapphire.GameServer;
        @inject('LayerManager') _layerManager: Sapphire.LayerManager;
        @inject('RecoveryModel') _recoveryModel: Sapphire.RecoveryModel;
        @inject('StateModel') _stateModel: Sapphire.StateModel;
        @inject('AudioModel') _audioModel: JupitersChoice.AudioModel;
        @inject('OrientationModel') _orientationModel: Sapphire.OrientationModel;
        @inject('TranslationsManager') _translationsManager: Sapphire.TranslationsManager;

        execute(): void {
            const response: any = this._gameServer.logicResponse;
            const restoreState = JSON.parse(response.restoreState);

            if (restoreState.fsNumber && restoreState.fsNumber > 0) {
                ShowFreeGameCmd.currentFreeGameSpinIdx = restoreState.fsNumber;

                this._componentManager.hideComponents(['SpinButton', 'StopAutoplayButton', 'AutoplaySpinRemainingText']);

                this._stateModel.changeSubgame('FreeGame');
                this._stateModel.changeState('DoFreeGameSpin');

                // make sure paylines/reels are in correct position
                this._componentManager.get('FreeGamePopup').setOrientation(this._orientationModel.getCurrentOrientation());
                this._componentManager.get('PaylineDisplay').setOrientation(this._orientationModel.getCurrentOrientation());
                this._componentManager.get('SkipPaylinesButton').setOrientation(this._orientationModel.getCurrentOrientation());
                this._componentManager.onOrientationChange(this._orientationModel.isLandscape, 'Reels');

                for (let i = 1; i < 9; i++) {
                    this._componentManager.get(`FreeGameFlame${i}`).show();
                    this._componentManager.get(`FreeGameFlame${i}`).play();
                }

                //update jupiter
                this._componentManager.get('JupiterBaseGame').pause();
                this._componentManager.get('JupiterFreeGameLandscape').play();
                this._componentManager.get('JupiterFreeGamePortrait').play();

                this._layerManager.setVisibility('BaseGameJupiter', false);
                this._layerManager.setVisibility('FreeGame', true);
                this._layerManager.setVisibility('FreeGameJupiter', true);

                this._componentManager.get('FreeGameSky').changeAnimation('clouds', false, true);
                this._componentManager.get('FreeGameSky').play();
                this._componentManager.get('BaseGameSky').play();

                this._componentManager.get('JupiterFreeGameLandscape').changeAnimation('idle');
                this._componentManager.get('JupiterFreeGamePortrait').changeAnimation('idle');
                this._audioModel.switchToFreeSpins();

                let freeSpinCountText = this._translationsManager.get('framework.xofy').replace('{0}', restoreState.fsNumber);
                freeSpinCountText = freeSpinCountText.replace('{1}', response.feature.value);
                this._componentManager.get('FreeSpinsCounter').setText(freeSpinCountText);

                // ensure total win is correct
                let currentFreeSpinInfo = response.freespins[ShowFreeGameCmd.currentFreeGameSpinIdx - 1];

                // deduct any base game wins
                if (response.winnings.length > 0) {
                    response.winnings.forEach(winning => {
                        currentFreeSpinInfo.runningTotal -= winning[2];
                    });
                }

                this._componentManager.get('WinMeter').setValue(this._currencyFormatter.format(currentFreeSpinInfo.runningTotal));
            }
        }
    }
}